import React from 'react';
import Layout from '../components/DashboardLayout';
import PageHeader from '../components/PageHeader';
import CycleCard from '../components/CycleCard';
import { Moon } from 'lucide-react';

/**
 * Cycle page — standalone Women's Wellness layer. Lives at /cycle so it's
 * demoable to anyone. Future gate: show only when user.gender === 'female'.
 *
 * Whatever the user logs here feeds Nikki via the chat_llm context pack —
 * she softens load in luteal, leans into mobility during menstruation,
 * matches energy in follicular/ovulation. All opt-in, fully reversible.
 */
const Cycle = () => {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto p-6 space-y-6">
        <PageHeader
          tag="Cycle Sync"
          tagColor="#ec4899"
          icon={Moon}
          title="Your cycle"
          subtitle="Opt in to share where you are in your cycle. Nikki will adjust load, nutrition and tone — never push you on tough days."
          testIdPrefix="cycle-page"
        />

        <CycleCard />

        <div className="hpme-card p-5">
          <div className="hpme-card-corner" />
          <p className="text-[10px] uppercase tracking-[0.2em] font-secondary font-bold text-zinc-500 mb-3">
            How Nikki uses this
          </p>
          <ul className="space-y-2 text-sm text-zinc-300 leading-relaxed">
            <li><span className="text-pink-400 font-semibold">Menstrual:</span> mobility, gentle work, more grace.</li>
            <li><span className="text-cyan-400 font-semibold">Follicular:</span> energy returns — slightly more challenging strength.</li>
            <li><span className="text-primary font-semibold">Ovulation:</span> peak energy window for harder sessions if you want.</li>
            <li><span className="text-purple-400 font-semibold">Luteal:</span> softer load, more rest, protein-forward meals.</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default Cycle;
